import { fetchQuery } from "react-relay";
import {
    Environment,
    Store,
    RecordSource,
    Network,
    FetchFunction
} from "relay-runtime";

import type { pricingPageRelayQuery$data } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars,
    shapePricingContentfulResponse
} from "../../contentful/graphql/pricing-page";

import { PricingContent } from "./get-pricing-content-gql.ts";

import type { SupportedLocales } from "../localization";

export interface GetPricingContentOptions {
    locale?: SupportedLocales;
    pricingTitleInternal?: string;
}

export const getPricingContent = async (
    productId: string,
    opts: GetPricingContentOptions = {}
): Promise<PricingContent | undefined> => {
    const { pricingTitleInternal } = opts;
    const fetchGraphQL: FetchFunction = async (request, variables) => {
        const resp = await fetch(
            "https://graphql.contentful.com/content/v1/spaces/xjcz23wx147q/environments/master",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization":
                        "Bearer fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8"
                },
                body: JSON.stringify({ query: request.text, variables })
            }
        );
        if (!resp.ok) {
            throw new Error("Response failed.");
        }
        return await resp.json();
    };

    const environment = new Environment({
        store: new Store(new RecordSource({})),
        network: Network.create(fetchGraphQL)
    });

    const pricingDataRaw = await fetchQuery(
        environment,
        PricingPageRelayQuery,
        getPricingPageRelayQueryVars(
            productId,
            window.location,
            pricingTitleInternal
        )
    )
        .toPromise()
        .then((data) => data)
        .catch((error) => {
            console.log(error);
        });

    const pricingDataRelay = shapePricingContentfulResponse(
        pricingDataRaw as pricingPageRelayQuery$data
    );
    return pricingDataRelay?.pricings?.edges?.[0]?.node;
};
